module.exports = __webpack_public_path__ + "../resources/img/eraser.10f31156.png";